import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {AppRouterModule} from "./app/app-router.module";
import {MODE} from "./app/models";

if (environment.production) {
  enableProdMode();
}

const params = (window as any).angularParams || {};
const shouldUseRouter = params.mode !== MODE.MODE_ROUTER;

const bootstrapModule = shouldUseRouter ? AppModule : AppRouterModule;

const BOOTSTRAP_FLAG = '__clientSearchAngularBootstrapped__';

const bootstrap = (): void => {
  const win = window as typeof window & Record<string, boolean>;

  if (win[BOOTSTRAP_FLAG] || !document.querySelector('app-root')) {
    return;
  }

  win[BOOTSTRAP_FLAG] = true;

  platformBrowserDynamic()
    .bootstrapModule(bootstrapModule)
    .catch((err) => {
      win[BOOTSTRAP_FLAG] = false;
      console.error(err);
    });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap, { once: true });
} else {
  bootstrap();
}
